import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UtilService } from './util-service';
import { GestaoPcaService } from './gestao-pca-service';
import { saveAs } from 'file-saver';

import { Observable } from 'rxjs';

@Injectable()
export class MonitoramentoDecisoesService {
    urlObterQuestoes: string;
    codigoModuloMonitoramentoDecisoes = 10;
    analiseAtual: any = null;
    idPaginaMonitoramentoDecisoes: string = "959";
    resumoAnalise: any;
    TIPO_ARQUIVO_MONITORAMENTO = 4;

    constructor(public http: HttpClient,
        private gestaoPcaService: GestaoPcaService,
        private utilService: UtilService) {
    }

    public obterIdPaginaMonitoramentoDecisoes() {
        return this.idPaginaMonitoramentoDecisoes;
    }

    public obterListaAnalises(codModulo): Observable<any> {
        this.urlObterQuestoes = "monitoramentoDecisoes?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    // public obterListaAnalises(codModulo): Observable<any> {
    //     this.urlObterQuestoes = "resumoAnalise/listarAnalises?idPca=" + this.gestaoPcaService.getPCA().id + "&codModulo=" + codModulo;
    //     return this.utilService.getJSON(this.urlObterQuestoes);
    // }

    public obterDeterminacoesJur(): Observable<any> {
       // this.urlObterQuestoes = "monitoramentoDecisoes/listarProcessosMonitoramento?idPca=" + this.gestaoPcaService.getPCA().id;
       // return this.utilService.getJSON(this.urlObterQuestoes);
       this.urlObterQuestoes = "monitoramentoDecisoes/listarProcessosMonitoramento?idPca=" + this.gestaoPcaService.getPCA().id;
       let result : Observable<any>  =  this.utilService.getJSON(this.urlObterQuestoes);
       result.subscribe(res => console.log(res));
       return result;
    }

    public obterDeterminacoesCertificado(): Observable<any> {
        this.urlObterQuestoes = "monitoramentoDecisoes/listarProcessosCertificado?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public obterPreVisualizar(): Observable<any> {
        this.urlObterQuestoes = "monitoramentoDecisoes/listarProcessosCertificado?idPca=" + this.gestaoPcaService.getPCA().id;;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public submeterCertificado(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "monitoramentoDecisoes/submeterCertificadoMonitoramento?idPca=" + this.gestaoPcaService.getPCA().id;;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public obterDeterminacoes(): Observable<any> {
        this.urlObterQuestoes = "monitoramentoDecisoes/listarProcessosImportados?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public obterDeterminacoesHistoricas(): Observable<any> {
        this.urlObterQuestoes = "monitoramentoDecisoes/listarHistoricoMonitoramento?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.getJSON(this.urlObterQuestoes);
    }

    public salvarDeterminacoes(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "monitoramentoDecisoes/salvarMonitoramento?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public salvarDeterminacoesJur(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "monitoramentoDecisoes/importarProcessos?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public finalizarDeterminacoes(jsonObjeto): Observable<any> {
        this.urlObterQuestoes = "monitoramentoDecisoes/finalizarModulo?idPca=" + this.gestaoPcaService.getPCA().id;
        return this.utilService.postJSON(this.urlObterQuestoes, jsonObjeto);
    }

    public listarEvidencias(id, idModuloAnalise) {
        let urlObtencaoDados = "arquivo/listarPorProcesso/" + id + "/" + idModuloAnalise;
        return this.utilService.getJSON(urlObtencaoDados);
    }

    public enviarEvidencia(event, id, idModuloAnalise) {
        let fileList: FileList = event.target.files;
        if (fileList.length > 0) {
            let file: File = fileList[0];
            let formData: FormData = new FormData();
            formData.append('arquivo', file, file.name);
            let envioRolXml: string = "arquivo/salvar?id=" + id +
                "&idTipo=" + this.TIPO_ARQUIVO_MONITORAMENTO + "&idModuloAnalise=" + idModuloAnalise;
            return this.utilService.postArquivo(envioRolXml, formData);
        }
    }

    public downloadEvidencia(idArquivo) {
        var headers = new HttpHeaders();
        headers.append('responseType', 'arraybuffer');
        this.utilService.getJSON("arquivo/download/" + idArquivo)
            .subscribe(data => {
                let contentType = "data:" + data.mimeType + ";base64";

                let byteCharacters = atob(data.decodedFile);

                let byteNumbers = new Array(byteCharacters.length);
                for (var i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);
                let file = new Blob([byteArray], { type: contentType });
                saveAs(file, data.filename);
            },
            error => console.log("Ocorreu um erro ao fazer o download do arquivo: " + error));
    }

    public deletarEvidencia(idArquivo) {
        let urlObtencaoDados: string = "arquivo/deletar/" + idArquivo;
        return this.utilService.deleteJSON(urlObtencaoDados);
    }
}



// WEBPACK FOOTER //
// ./src/providers/monitoramento-decisoes-service.ts